var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showLogin)?_c('login',{on:{"success":function($event){return _vm.$router.push('/dashboard')}}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }